import { Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { AiChatOverlayService } from '@services/helpers/ai-chat-overlay.service';
import { FloatingAiButtonComponent } from '@shared/components/floating-ai-button/floating-ai-button.component';

@Component({
  selector: 'app-ai-chat-global-overlay',
  imports: [AsyncPipe, FloatingAiButtonComponent],
  templateUrl: './ai-chat-global-overlay.component.html',
  styleUrls: ['./ai-chat-global-overlay.component.scss'],
})
export class AiChatGlobalOverlayComponent {
  readonly state$ = this.aiChatOverlayService.state$;

  constructor(private readonly aiChatOverlayService: AiChatOverlayService) {}
}
